/**
 * Usa la función de la librería fetchJsonp para poder evitar el problema de cors
 * En la respuesta hace la llamada a la función "handleResponse" para poder manipular los datos
 */

import fetchJsonp from 'fetch-jsonp'
import { urlToDictionaryCall } from './buildEndpoint'
import { handleResponse } from './handleDictionaryRes'

export function dictionaryResponse() {
  fetchJsonp(urlToDictionaryCall)
    .then((res) => res.json())
    .catch((error) => {
      console.info(
        `Esta url no está contemplada en el diccionario o ha ocurrido un error en la llamda ${error}`
      )
      return { value: undefined }
    })
    .then(({ value }) => {
      if (typeof value !== 'undefined') {
        handleResponse(JSON.parse(value))
      } else {
        handleResponse(value)
      }
    })
}
